"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getFontClassNameFromSize = exports.getFontClassNameFromSize = function getFontClassNameFromSize(size) {
  switch (size) {
    case 'small':
      return 't-small';

    default:
      return 't-body';
  }
};

var getTagPaddingFromSize = exports.getTagPaddingFromSize = function getTagPaddingFromSize(size) {
  switch (size) {
    case 'large':
      return '.25rem .5rem';
    // pv2 ph3

    case 'small':
      return '0 .125rem';
    // pv0 ph1

    default:
      return '.25rem .5rem';
    // pv2 ph3
  }
};

var getControlHeightFromSize = exports.getControlHeightFromSize = function getControlHeightFromSize(size) {
  switch (size) {
    case 'large':
      return '3rem';

    case 'small':
      return '2rem';

    default:
      return '2.5rem';
  }
};